<template>
  <div>
    <slide-show :swiperData="swiperData"></slide-show>
    <div class="first-article d-center">
      <paper-plates :xxData="xxData"></paper-plates>
    </div>
    <div>
      <div class="second-article d-center">
        <article-list
          :title1="jxTitle"
          :title2="kyTitle"
          :leftData="jxData"
          :rightData="kyData"
        ></article-list>
      </div>
      <div class="video d-center">
        <video-bar></video-bar>
      </div>
      <div class="second-article d-center">
        <article-list
          :title1="zcTitle"
          :title2="ghTitle"
          :leftData="zcData"
          :rightData="ghData"
        ></article-list>
      </div>
    </div>
    <div class="venues d-center">
      <!-- <div class="opacity"></div> -->
      <img class="venuesbg" src="../../assets/img/imagebg.png" />
      <sports-venues></sports-venues>
    </div>
    <div
      style="
        padding: 16px 0;
        width: 1100px;
        margin-left: calc(50% - 550px);
        display: flex;
        justify-content: space-between;
      "
    >
      <a href="http://www.zucc.edu.cn/" target="_blank"
        ><img src="../../assets/img/zucc.svg" style="height: 56px"
      /></a>

      <a href="http://jyt.zj.gov.cn/col/col1532981/index.html" target="_blank"
        ><img src="../../assets/img/jyt.png" style="height: 56px"
      /></a>

      <a href="http://tymy.zucc.edu.cn/" target="_blank"
        ><img src="../../assets/img/tymy.jpg" style="height: 56px"
      /></a>
    </div>
  </div>
</template>
<script>
import SlideShow from '../../components/SlideShow/index.vue'
import PaperPlates from './PaperPlates/index.vue'
import ArticleList from './ArticleList/index.vue'
import VideoBar from './VideoBar/index.vue'
import SportsVenues from './SportsVenues/index.vue'
import { getHomeLists, getSwiper } from '@/api/api'
export default {
  name: 'Home',
  components: {
    SlideShow,
    PaperPlates,
    ArticleList,
    VideoBar,
    SportsVenues,
  },
  data() {
    return {
      jxTitle: '教学信息',
      kyTitle: '科研信息',
      zcTitle: '政策文件',
      ghTitle: '工会工作',
      jxData: [],
      kyData: [],
      zcData: [],
      ghData: [],
      xxData: [],
      swiperData: [
        // {
        //   id: 0,
        //   subtitle: '浙大城市学院第二十届运动会落幕',
        //   title: '又是一年秋意浓,正好的天气，遇到正青春的你。',
        //   rotatePictures: require('../../assets/img/banner.png'),
        // },
        // {
        //   id: 1,
        //   subtitle: '浙大城市学院第二十届运动会落幕',
        //   title: '又是一年秋意浓,正好的天气，遇到正青春的你。',
        //   rotatePictures: require('../../assets/img/zucc.jpg'),
        // },
        // {
        //   id: 2,
        //   subtitle: '浙大城市学院第二十届运动会落幕',
        //   title: '又是一年秋意浓,正好的天气，遇到正青春的你。',
        //   rotatePictures: require('../../assets/img/banner.png'),
        // },
        // {
        //   id: 3,
        //   subtitle: '浙大城市学院第二十届运动会落幕',
        //   title: '又是一年秋意浓,正好的天气，遇到正青春的你。',
        //   rotatePictures: require('../../assets/img/banner.png'),
        // },
      ],
    }
  },
  created() {
    this.getInfo()
    this.getSwiperData()
  },
  methods: {
    getInfo() {
      getHomeLists().then((res) => {
        if (res.data.statusCode == 1) {
          this.jxData = res.data.obj.cmsResListJY.slice(0, 8)
          this.kyData = res.data.obj.cmsResListKY.slice(0, 8)
          this.zcData = res.data.obj.cmsResListZC.slice(0, 8)
          this.ghData = res.data.obj.cmsResListGH.slice(0, 8)
          this.xxData = res.data.obj.cmsResListXX.slice(0, 7)
        }
      })
    },
    getSwiperData() {
      getSwiper('', 1, 4).then((res) => {
        if (res.data.statusCode == 1) {
          this.swiperData = res.data.obj.data
          //   this.swiperData[0].rotatePictures = require('../../assets/img/123.jpg')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
.first-article {
  width: 100%;
  min-width: 1100px;
  height: 422px;
  background-color: #f9f9f9;
}
.second-article {
  width: 100%;
  min-width: 1100px;
  //   height: 901px;
  background-color: $white;
}
.video {
  width: 100%;
  min-width: 1100px;
}
.venues {
  width: 100%;
  min-width: 1100px;
  height: 756px;
  //   background-image: url('../../assets/img/imagebg.png');
  //   background-repeat: no-repeat;
  //   background-size: 100%;
  margin-top: 48px;
  position: relative;
  z-index: 0;
}
.venuesbg {
  position: absolute;
  width: 100%;
  min-width: 1100px;
  height: 100%;
  opacity: 0.4;
}
.opacity {
  position: absolute;
  width: 100%;
  min-width: 1100px;
  height: 100%;
  opacity: 0.6;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: -1;
}
</style>
